import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getAssetTypeListSaga = createAction(
  "GET_ASSET_TYPE",
  ({ payload, params }: SagaActionParams<Type.AssetTypeDto[]>) => ({
    payload,
    url: "/api/admin/assettypes" + (params ? params : ""),
  })
);
export const getAssetTypeDetailsSaga = createAction(
  "GET_ASSET_TYPE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AssetTypeDetailDto>) => ({
    payload,
    url: "/api/admin/assettypes/" + id,
  })
);
export const createAssetTypeSaga = createAction(
  "CREATE_ASSET_TYPE",
  ({ payload, body }: SagaActionParams<Type.AssetTypeDto>) => ({
    payload,
    url: "/api/admin/assettypes",
    body,
  })
);
export const updateAssetTypeSaga = createAction(
  "UPDATE_ASSET_TYPE",
  ({ payload, id, body }: SagaActionParams<Type.AssetTypeDto>) => ({
    payload,
    url: "/api/admin/assettypes/" + id,
    body,
  })
);
export const deleteAssetTypeSaga = createAction(
  "DELETE_ASSET_TYPE",
  ({ payload, id }: SagaActionParams<Type.AssetTypeDto>) => ({
    payload,
    url: "/api/admin/assettypes/" + id,
  })
);

const assettypesSaga = [
  takeLatest<any>(
    getAssetTypeListSaga.toString(),
    (payload: SagaGenericParams<Type.AssetTypeDto[]>) =>
      getSaga<Type.AssetTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getAssetTypeDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.AssetTypeDetailDto>) =>
      getSaga<Type.AssetTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createAssetTypeSaga.toString(),
    (payload: SagaGenericParams<Type.AssetTypeDto>) =>
      postSaga<Type.AssetTypeDto>(payload)
  ),
  takeLatest<any>(
    updateAssetTypeSaga.toString(),
    (payload: SagaGenericParams<Type.AssetTypeDto>) =>
      putSaga<Type.AssetTypeDto>(payload)
  ),
  takeLatest<any>(
    deleteAssetTypeSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.AssetTypeDto>(payload)
  ),
];

export default assettypesSaga;
